export default __webpack_public_path__ + "static/media/undraw_voting_nvu7.9115e3d0.png";